module.exports = __webpack_public_path__ + "72f6fd218b59c42e804cb543cfc53598.woff2";